import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    titleNew: {
        id: 'modal.settings.pin.title_new',
        defaultMessage: 'Enter new PIN',
    },
    titleConfirm: {
        id: 'modal.settings.pin.title_confirm',
        defaultMessage: 'Confirm PIN',
    },
    close: {
        id: 'modal.settings.pin.close',
        defaultMessage: 'Close',
    },
    continue: {
        id: 'modal.settings.pin.continue',
        defaultMessage: 'Continue',
    },
    enter4Digits: {
        id: 'modal.settings.pin.enter_4_digits',
        defaultMessage: 'Enter all 4 digits',
    },
    pinsDontMatch: {
        id: 'modal.settings.pin.pins_dont_match',
        defaultMessage: "PINs don't match. Try again",
    },
})
